import React from "react";
import { Button, Box } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import AddIcon from "@mui/icons-material/Add";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import uploadicon from "../../assets/images/uploadicon.svg";
import { useUser } from "../../context/AuthContext";

const ActionButtons = ({
  onFilterClick,
  onAddClick,
  onUploadClick,
  filterObj,
  showUpload = true,
}) => {
  const { user } = useUser();
  const isFilterApplied = Object.keys(filterObj).some(
    (key) =>
      filterObj[key] &&
      (Array.isArray(filterObj[key])
        ? filterObj[key].length > 0
        : filterObj[key])
  );

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mt: "2rem",
        mb: "1.5rem",
        gap: "1rem",
        width: "100%",
      }}
    >
      <Box sx={{ display: "flex", gap: "1rem" }}>
        {!user?.companyAdmin ? (
          <>
            <Button
              variant="contained"
              endIcon={<AddIcon />}
              sx={{
                backgroundColor: "#1c486b",
                fontSize: "16px",
                textTransform: "none",
                fontFamily: "Inter",
                fontWeight: "500",
                "&:hover": {
                  backgroundColor: "#1c486b",
                  opacity: 0.9,
                },
              }}
              onClick={onAddClick}
            >
              Add New
            </Button>
            {showUpload && (
              <Button
                variant="contained"
                onClick={onUploadClick}
                endIcon={<img src={uploadicon} alt="upload" />}
                sx={{
                  backgroundColor: "#fff",
                  fontSize: "16px",
                  textTransform: "none",
                  color: "rgba(28, 72, 107, 1)",
                  fontFamily: "Inter",
                  fontWeight: "500",
                  "&:hover": {
                    backgroundColor: "#fff",
                    opacity: 0.9,
                  },
                }}
              >
                Upload
              </Button>
            )}
          </>
        ) : null}
      </Box>
      <Button
        variant="contained"
        onClick={onFilterClick}
        sx={{
          backgroundColor: "#ffffff",
          textTransform: "none",
          fontSize: "16px",
          fontFamily: "Inter",
          fontWeight: "500",
          color: "black",
          "&:hover": { backgroundColor: "#1c486b", color: "#FFFFFF" },
          "&:hover .dot-icon": { color: "#FFFFFF" },
        }}
      >
        Filter
        <FilterListIcon sx={{ marginLeft: "0.5rem" }} />
        {isFilterApplied && (
          <FiberManualRecordIcon
            className="dot-icon"
            sx={{
              fontSize: "16px",
              fontWeight: "500",
              color: "#488257",
              marginLeft: "5px",
              fontFamily: "Inter",
              textTransform: "none",
            }}
          />
        )}
      </Button>
    </Box>
  );
};

export default ActionButtons;
